// Skeleton.jsx

import React from "react";
import "./skeleton.css";
import ModalSkeleton from "./ModalSkeleton";
import PageSkeleton from "./PageSkeleton";
import Welcome from "./WelcomeSkeleton";
const Skeleton = ({ type }) => {
  let skeletonMarkup;

  switch (type) {
    case "page":
      skeletonMarkup = <PageSkeleton />;
      break;
    case "modal":
      skeletonMarkup = <ModalSkeleton />;
      break;
    case "welcome":
      skeletonMarkup = <Welcome />;
      break;
    default:
      skeletonMarkup = <div className="default-skeleton"></div>;
      break;
  }

  return <div>{skeletonMarkup}</div>;
};

export default Skeleton;
